<template>
  <div class="modal-overlay">
    <div class="mmodal-content" style="max-width: 70vw">
      <div class="modal-header">
        <h5 class="modal-title">Test/Scan Result</h5>
        <button type="button" class="close" @click="closeModal">&times;</button>
      </div>

      <div class="modal-body">
        <div v-if="loading">Loading result...</div>

        <div v-else>
          <!-- <div class="form-group">
            <label><strong>Result:</strong></label>
            <p>{{ resultData.result }}</p>
          </div> -->

          <div class="form-group">
            <label><strong>Notes:</strong></label>
            <pre style="white-space: pre-wrap">{{ resultData.note }}</pre>
          </div>

          <div class="form-group" v-if="resultData.file">
            <label><strong>Attached File:</strong></label>
            <div>
              <a
                :href="resultData.file"
                target="_blank"
                class="btn btn-sm btn-info"
              >
                View / Download
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { generalApiRequest } from "@/api/apiIndex.js";

export default {
  name: "ViewResultModal",
  props: {
    service_id: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      resultData: {},
      loading: true,
    };
  },
  methods: {
    closeModal() {
      this.$emit("hide-view-result-modal");
    },
    async fetchResult() {
      this.loading = true;
      console.log(this.service_id);

      try {
        const response = await generalApiRequest(
          `services/get_results_by_id/${this.service_id}`,
          "GET",
          {},
          1
        );

        if (response.status === "success") {
          this.resultData = response.data;
        } else {
          alert("Result not found.");
          this.closeModal();
        }
        this.loading = false;
      } catch (error) {
        console.error("Error fetching result:", error);
        alert("Failed to load result.");
        this.closeModal();
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    this.fetchResult();
  },
};
</script>

<style scoped>
.modal-body {
  padding: 1rem;
  overflow-y: auto;
  flex-grow: 1;
}
.close {
  background: rgb(233, 22, 22);
  border: 1px solid rgb(182, 178, 178);
  font-size: 1.5rem;
  color: white;
  line-height: 1;
  cursor: pointer;
}
</style>
